module.exports = __webpack_public_path__ + "static/media/party1.40e8adaf.mp3";